<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :submit="handleCreateRoute"
        size="xl"
        :rules="ruleFormCreateRoute"
        :title="$t('labels.addRoute')"
        @close="close">
        <div
            :style="{ minWidth: minWidthScroll }"
            class="flex w-full h-full gap-3">
            <div class="flex w-full h-full gap-3">
                <div class="w-1/2">
                    <ul
                        v-if="formData.positions?.length"
                        class="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical mt-[40px]">
                        <li
                            v-for="(position, index) in formData.positions"
                            :key="index">
                            <div class="timeline-middle">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                    class="h-5 w-5">
                                    <path
                                        fill-rule="evenodd"
                                        d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div class="w-full timeline-end">
                                <div class="translate-y-[-40px]">
                                    <div class="flex justify-center items-center gap-2">
                                        <hts-admincp-select-location
                                            ref="selectLocation"
                                            v-model="position.locationId"
                                            v-model:text="position.locationName"
                                            class="w-full"
                                            required
                                            name="location"
                                            prop="location"
                                            key-id="_id"
                                            key-label="locationName"
                                            :label="$t('labels.location')"
                                            filterable
                                            clearable
                                            @change="(value) => handleLocationChange(value, index)" />

                                        <div>
                                            <hi-x-circle-icon
                                                class="h-6 w-6 mt-8 text-error-500 hover:text-error-700 cursor-pointer"
                                                @click="() => handleDeletePosition(index)" />
                                        </div>
                                    </div>

                                    <div
                                        v-if="getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.distance"
                                        v-loading="mapLoading.route"
                                        class="p-4 bg-white rounded-lg shadow-sm border border-gray-100 mt-5">
                                        <!-- Distance Section -->
                                        <p class="font-medium text-gray-700 flex items-center gap-2 mt-3 px-2 py-2 bg-gray-50 rounded-md">
                                            <span class="text-primary-600">
                                                <svg
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447-2.724A1 1 0 0021 13.382V2.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                                                </svg>
                                            </span>
                                            Quãng đường:
                                            <span class="text-primary-600">
                                                {{ $formatters.mToKm(getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.distance) }} km
                                            </span>
                                        </p>

                                        <p class="font-medium text-gray-700 flex items-center gap-2 mt-1 px-2 py-2 bg-gray-50 rounded-md">
                                            <span class="text-primary-600">
                                                <svg
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </span>
                                            Thời gian:
                                            <span class="text-primary-600">
                                                {{
                                                    $formatters.convertMinutesToNaturalLanguage(
                                                        getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.duration,
                                                        'second'
                                                    )
                                                }}
                                            </span>
                                        </p>

                                        <div class="flex items-center justify-between mt-3 px-2 py-2 bg-gray-50 rounded-md">
                                            <!-- Toll Stations Label -->
                                            <p class="font-medium text-gray-700 flex items-center gap-2">
                                                <span class="text-yellow-600">
                                                    <svg
                                                        class="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                </span>
                                                Trạm thu phí:
                                            </p>

                                            <button
                                                class="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1.5 transition-colors duration-200"
                                                type="button"
                                                @click="editTollStations(position._id, formData.positions?.[index + 1]?._id)">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    class="h-4 w-4"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    stroke-width="2">
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15.414 9 16l.586-2.828L16.414 6.586a2 2 0 00-2.828-2.828z" />
                                                </svg>
                                                Chỉnh sửa
                                            </button>
                                        </div>
                                        <ul class="list-disc ml-6 text-gray-600">
                                            <li
                                                v-for="toll in getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.tollStations"
                                                :key="toll"
                                                class="text-start text-primary-600">
                                                {{ toll.locationName }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <hr v-if="index < formData.positions.length - 1" >
                        </li>
                    </ul>

                    <div class="mt-10 w-full flex justify-between">
                        <hts-form-button
                            color="success"
                            icon-name="hi-plus-circle-icon"
                            icon-position="right"
                            type="button"
                            size="small"
                            @click="handleAddPosition()">
                            Thêm địa điểm
                        </hts-form-button>
                        <hts-form-button
                            color="main"
                            icon-name="hi-arrow-path-icon"
                            icon-position="right"
                            type="button"
                            size="small"
                            @click="handleReDrawRoute()">
                            Đặt lại tuyến mặc định
                        </hts-form-button>
                    </div>
                    <!-- class="pl-[64px] pr-8 mt-5" -->
                    <div class="mt-5">
                        <hts-select-category-vehicle
                            v-model="formData.vehicleCategoryIds"
                            required
                            prop="workflowData"
                            multiple
                            :data-multiple="formData.vehicleCategories || []" />

                        <hts-form-input
                            v-model="formData.tolerance"
                            :label="$t('labels.tolerance')"
                            type="number">
                            <template #suffix>
                                Km
                            </template>
                        </hts-form-input>

                        <hts-form-input
                            v-model="formData.totalDistance"
                            :label="$t('labels.totalKm')"
                            type="number">
                            <template #suffix>
                                Km
                            </template>
                        </hts-form-input>
                        <hts-form-input
                            v-model="formData.totalDuration"
                            :label="$t('labels.totalDuration')"
                            type="number">
                            <template #suffix>
                                {{ $t('labels.hour') }}
                            </template>
                        </hts-form-input>

                        <hts-form-textarea
                            v-model="formData.description"
                            :label="$t('labels.description')" />
                    </div>
                </div>
                <div class="w-1/2">
                    <div class="w-full h-full">
                        <hts-map-route
                            ref="map"
                            center-marker
                            :route="markers"
                            :route-separated="routes"
                            :draggable="draggable"
                            :lat-lng-location-routes="CLatLngLocationRoutes"
                            :show-location="showLocation"
                            @updateDirections="updateDirections">
                            <template #top>
                                <div class="flex min-h-5 justify-end gap-3">
                                    <hts-map-icon-location store-key="route" />
                                </div>
                            </template>
                        </hts-map-route>
                    </div>
                </div>
            </div>
        </div>

        <hts-modal
            :show="openEditTollStations"
            title="Chỉnh sửa trạm thu phí"
            @close="openEditTollStations = false">
            <!-- Danh sách trạm -->

            <div v-if="tollStationsEdit.length">
                <div
                    v-for="(toll, index) in tollStationsEdit"
                    :key="toll._id"
                    class="flex items-center gap-2 mb-2 w-full">
                    <hts-admincp-select-node
                        v-model="toll._id"
                        v-model:text="toll.locationName"
                        type="TOLL_STATION"
                        key-id="_id"
                        key-label="locationName"
                        prop="node"
                        name="node"
                        class="w-full"
                        label=""
                        @change="(value) => tollStationChange(value, index)" />

                    <hts-form-button
                        color="error"
                        type="button"
                        @click="removeTollStations(index)">
                        Xoá
                    </hts-form-button>
                </div>
            </div>
            <div v-else>
                <p>
                    Tuyến đường không qua trạm thu phí
                </p>
            </div>

            <hts-form-button
                color="success"
                type="button"
                @click="addTollStations()">
                Thêm
            </hts-form-button>

            <div class="mt-4 text-right">
                <!-- @click="saveTollStations" -->
                <hts-form-button
                    color="primary"
                    @click="saveTollStations()">
                    Lưu
                </hts-form-button>
            </div>
        </hts-modal>
    </hts-drawer>
</template>
<script setup lang="ts">
import routeMap from './route-map'
import screen from '~/components/utils/screen'
const route = useRoute()
const router = useRouter()

const { map: mapStore } = $store()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const { $formatters } = useNuxtApp()

const emits = defineEmits(['refreshTables'])
const map = ref()

const {
  markers,
  setMarkers,
  routes,
  setRoutes,
  mapLoading,
  getRoutingPosition,
  routingPositions,
  updateDirections,
  draggable,
  CLatLngLocationRoutes,
  showLocation,
  setRoutingPositions,
  setRoutingPositionTollStations
} = routeMap('route')

const visible = ref(false)
const loading = ref(false)
const openEditTollStations = ref(false)
const tollStationsEdit = ref<{ [key: string]: any }[]>([])
const startPositionId = ref('')
const endPositionId = ref('')

const formData = ref<{
  positions: { [key: string]: any }[]
  vehicleCategoryIds: string[]
  vehicleCategories: { [key: string]: any }[]
  tolerance: number | null
  description: string
  totalDistance: number
  totalDuration: number
}>({
  positions: [
    {
      locationId: '',
      locationName: '',
      lat: '',
      lng: '',
      address: '',
      _id: $formatters.generateId()
    },
    {
      locationId: '',
      locationName: '',
      lat: '',
      lng: '',
      address: '',
      _id: $formatters.generateId()
    }
  ],
  vehicleCategoryIds: [],
  vehicleCategories: [],
  tolerance: null,
  totalDistance: 0,
  totalDuration: 0,
  description: ''
})

const init = ref(false)
const totalKm = computed(() => {
  return (routingPositions.value?.route?.distance || 0) + (formData.value.tolerance || 0)
})
const totalTime = computed(() => {
  return routingPositions.value?.route?.duration || 0
})
watch(
  () => totalKm.value,
  (val) => {
    if (!init.value) {
      return
    }
    formData.value.totalDistance = val || 0
  }
)
watch(
  () => totalTime.value,
  (val) => {
    if (!init.value) {
      return
    }
    formData.value.totalDuration = val || 0
  }
)

const open = async () => {
  mapStore.setShowLocation({ route: false })
  mapLoading.value.route = true
  loading.value = true
  visible.value = true

  const requestRouteId = route.query['request-route-id']
  if (requestRouteId && typeof requestRouteId === 'string') {
    await getData(requestRouteId)
  }

  init.value = true
  setTimeout(() => {
    handlePositionsChanged()
    loading.value = false
    mapLoading.value.route = false
  }, 1000)
}

const getData = async (id: string) => {
  const api = $url.route.route.getRequest
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value

  if (resData?.success) {
    formData.value = resData.data
    formData.value.description = ''
    routingPositions.value = {}
  }
}
const editTollStations = (s: string, e: string) => {
  openEditTollStations.value = true
  startPositionId.value = s
  endPositionId.value = e
  tollStationsEdit.value = $lodash.cloneDeep(getRoutingPosition(s, e)?.tollStations || [])
}

const removeTollStations = (index: number) => {
  tollStationsEdit.value.splice(index, 1)
}

const addTollStations = () => {
  tollStationsEdit.value.push({
    _id: '',
    locationName: '',
    fullNameNode: '',
    locationId: ''
  })
}

const tollStationChange = (value: any[], index: number) => {
  if (!tollStationsEdit.value?.[index]) {
    return
  }
  tollStationsEdit.value[index].fullNameNode = value[0]?.name
  tollStationsEdit.value[index].locationId = value[0]?.location
}

const saveTollStations = () => {
  setRoutingPositionTollStations(startPositionId.value, endPositionId.value, tollStationsEdit.value || [])
  openEditTollStations.value = false
  setMarkers(formData.value.positions, {
    renderMarkerByIndexNumber: true
  })
}

const close = () => {
  visible.value = false
}

const reset = () => {
  formData.value = {
    positions: [
      {
        locationId: '',
        locationName: '',
        lat: '',
        lng: '',
        address: '',
        _id: $formatters.generateId()
      },
      {
        locationId: '',
        locationName: '',
        lat: '',
        lng: '',
        address: '',
        _id: $formatters.generateId()
      }
    ],
    vehicleCategoryIds: [],
    vehicleCategories: [],
    tolerance: null,
    totalDistance: 0,
    totalDuration: 0,
    description: ''
  }
  handlePositionsChanged()
  routingPositions.value = {}
  router.push({ query: {} })
}

const ruleFormCreateRoute = {}

const handleAddPosition = () => {
  formData.value.positions.push({
    locationId: '',
    locationName: '',
    lat: '',
    lng: '',
    address: '',
    _id: $formatters.generateId()
  })
}

const handleDeletePosition = (index: number) => {
  if (index < 0 || index >= formData.value.positions.length) {
    return
  }

  if (formData.value.positions.length <= 2) {
    formData.value.positions[index].locationId = ''
    formData.value.positions[index].locationName = ''
    formData.value.positions[index].lat = ''
    formData.value.positions[index].lng = ''
    formData.value.positions[index].address = ''
    handlePositionsChanged()

    return
  }

  formData.value.positions.splice(index, 1)

  handlePositionsChanged()
}

const handleLocationChange = (values: { [key: string]: any }, index: number) => {
  if (Array.isArray(values) && values.length) {
    const value = values[0]
    formData.value.positions[index].lat = value.lat
    formData.value.positions[index].lng = value.lng
    formData.value.positions[index].address = value.address
  } else {
    formData.value.positions[index].lat = ''
    formData.value.positions[index].lng = ''
    formData.value.positions[index].address = ''
  }
  setRoutingPositions()
  handlePositionsChanged()
}

const handlePositionsChanged = () => {
  setMarkers(formData.value.positions, {
    renderMarkerByIndexNumber: true
  })
  setRoutes(formData.value.positions, {
    renderMarkerByIndexNumber: true
  })
}

const handleCreateRoute = async () => {
  const api = $url.route.route.create

  const dataBody: { [key: string]: any } = {
    ...formData.value,
    routingPositions: routingPositions.value
  }

  const data: any = await $api(api, { body: dataBody })

  const resData: any = data.data.value
  if (resData.success) {
    process.client && $toast().success('Thêm tuyến thành công')
    emits('refreshTables')
    reset()
    close()
  }
}

const handleReDrawRoute = () => {
  map.value && map.value.reDrawRoute()
}

defineExpose({ open, close })
</script>

<style scoped>
.timeline-vertical:where(.timeline-snap-icon) > li {
  --timeline-col-start: minmax(0, 0fr);
}
</style>
